import { NgModule } from '@angular/core';
import { CommonPackageModule } from 'src/app/modules/common-package.module';
import { GridComponent } from './grid/grid.component';
import { HomeComponent } from './home/home.component';
import { MultiCheckFilterComponent } from './multicheckbox-filter/multicheckbox-filter.component';
import { CommonFeatureModule } from '../common/common.module';
import { HomeRoutingModule } from './home-routing.module';

@NgModule({
  declarations: [
    HomeComponent,
    GridComponent,
    MultiCheckFilterComponent
  ],
  imports: [
    CommonPackageModule,
    CommonFeatureModule,
    HomeRoutingModule
  ]
})
export class DashobardHomeModule { }
